import { type ReactNode } from 'react';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

type MobileHeaderMenuItemProps = {
  onClick: () => void;
  title: string;
  renderIcon?: () => ReactNode;
  disabled?: boolean;
};

const MobileHeaderMenuItem = ({ onClick, renderIcon, disabled, title }: MobileHeaderMenuItemProps) => {
  return (
    <MenuItem onClick={onClick} disabled={disabled}>
      {renderIcon && <ListItemIcon>{renderIcon()}</ListItemIcon>}
      <ListItemText>{title}</ListItemText>
    </MenuItem>
  );
};

export { MobileHeaderMenuItem };
